var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D19E3E8E-B615-4F1E-B941-272CEBDB5907") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-/-My-groups-/-Create-a-group-(For-Creater)",
    transform: "translate(-308.000000, -501.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(200.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-list",
    transform: "translate(63.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company-icon",
    transform: "translate(45.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-visit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.120938,7.42551862 L141.120938,2 C141.120938,0.8954305 140.225507,-2.02906125e-16 139.120938,0 L74.166875,0 C73.0623055,2.02906125e-16 72.166875,0.8954305 72.166875,2 L72.166875,7.4665625 C72.166875,8.571132 71.2714445,9.4665625 70.166875,9.4665625 L55.048125,9.4665625 C53.9435555,9.4665625 53.048125,10.361993 53.048125,11.4665625 L53.048125,134.703125 L157.925938,134.703125 C159.030507,134.703125 159.925938,133.807694 159.925938,132.703125 L159.925938,11.4757314 C159.925938,10.3738087 159.034634,9.47947843 157.932718,9.47574287 L143.114157,9.42550713 C142.012241,9.42177157 141.120938,8.52744126 141.120938,7.42551862 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2540625,160 C36.3200146,160 26.545,141.278125 17.9346875,126.235313 C5.9165625,105.237813 0.0740625,90.72875 0.0740625,81.879375 C0.0740625,60.2753125 17.6503125,42.6990625 39.254375,42.6990625 C60.85875,42.6990625 78.435,60.2753125 78.435,81.879375 C78.435,90.72875 72.5928125,105.237813 60.574375,126.235 C51.9640625,141.277813 42.1881104,160 39.2540625,160 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29375,105.865625 L114.875,105.865625 C115.979569,105.865625 116.875,106.761056 116.875,107.865625 L116.875,134.7 L96.29375,134.7 L96.29375,107.865625 C96.29375,106.761056 97.1891805,105.865625 98.29375,105.865625 Z",
    id: "Rectangle-path",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 83.4528125,
    y: 67.875,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(83.437500, 30.625000)",
    fill: "#37633A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0153125,
    y: 56.05625,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0153125,
    y: 0.071875,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0153125,
    y: 18.875,
    width: 18.178125,
    height: 9.403125
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFDA2D",
    x: 112.2875,
    y: 30.696875,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    fill: "#37633A",
    x: 112.2875,
    y: 67.875,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_1_1_",
    fill: "#FEF192",
    x: 112.2875,
    y: 86.68125,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 112.2875,
    y: 30.696875,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_2_1_",
    fill: "#37633A",
    x: 112.2875,
    y: 49.5,
    width: 18.178125,
    height: 9.403125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2540625,100.685 C28.8846875,100.685 20.4484375,92.24875 20.4484375,81.879375 C20.4484375,71.51 28.8846875,63.07375 39.2540625,63.07375 C49.6234375,63.07375 58.0596875,71.51 58.0596875,81.879375 C58.0596875,92.24875 49.62375,100.685 39.2540625,100.685 Z",
    id: "Shape",
    fill: "#FEF192"
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.6c4a90563f74cb2b2a251a20d8e80172.svg";
export { ForwardRef as ReactComponent };